module.exports = __webpack_public_path__ + "img/dm.53e4073a.svg";